import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, TableSortLabel, Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

import { ReactComponent as SortAscIcon } from '../../assets/images/sort-asc-icon.svg';
import { ReactComponent as SortDescIcon } from '../../assets/images/sort-desc-icon.svg';

const EnhancedTableHead = (props) => {
  const { order, orderBy, onRequestSort, headCells } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            sx={{ ...headCell.sx }}
            align="left"
            key={headCell.id}
            sortDirection={orderBy === headCell.id ? order : false}
            size="small">
            <TableSortLabel
              sx={{
                padding: 0,
                textAlign: 'left'
              }}
              hideSortIcon={headCell.hideSortIcon}
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={headCell.hideSortIcon ? null : createSortHandler(headCell.id)}
              IconComponent={orderBy === headCell.id ? SortAscIcon : SortDescIcon}>
              {headCell.label}

              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  headCells: PropTypes.array.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired
};

export default memo(EnhancedTableHead);
